import * as actionType from './type';

const initialState = {
    lead: [],
    order: [],
    invoice: [],
    user: [],
    product: [],
    isSalesLoading: false,
    isPieChartLoader: false
}

export default function(state = initialState, action) {
    switch(action.type) {
        case actionType.RECEIVED_GET_LEAD: {
            return {
                ...state,
                lead: action?.payload
            }
        }

        case actionType.RECEIVED_GET_PRODUCT: {
            return {
                ...state,
                product: action?.payload
            }
        }

        case actionType.RECEIVED_GET_ORDER: {
            return {
                ...state,
                isSalesLoading: false,
                order: action?.payload
            }
        }



        case actionType.RECEIVED_GET_USER: {
            return {
                ...state,
                user: action?.payload
            }
        }

        case actionType.RECEIVED_GET_INVOICE: {
            return {
                ...state,
                invoice: action?.payload
            }
        }

        case actionType.REQUEST_GET_ORDER: {
            return {
                ...state,
                isSalesLoading: action?.payload
            }
        }

         case actionType.REQUEST_GET_LEAD: {
            return {
                ...state,
                isPieChartLoader: action?.payload
            }
        }

        default: 
            return {
                ...state
            }
    }

}